// extracted by mini-css-extract-plugin
export default {"card":"IssueCard_card__NiiMz","title":"IssueCard_title__7NX65"};